function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { usePhoneInput } from "../../Hooks";
import StepOne from "./Components/StepOne";
import StepTwo from "./Components/StepTwo";
import { toast } from "react-toastify";
import { LoadingSpinner } from "../../components/Common/LoadingUI";
import StepThree from "./Components/StepThree";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var DealEnquiry = function DealEnquiry(_ref) {
  var _prefilledData$, _prefilledData$2, _prefilledData$3, _prefilledData$4;
  var dealRedemptionId = _ref.dealRedemptionId,
    prefilledData = _ref.prefilledData,
    winnreAuth = _ref.winnreAuth;
  var theme = useTheme();
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    unitConfig = _useState6[0],
    setUnitConfig = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    possessionDuration = _useState8[0],
    setPossessionDuration = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    moveInDuration = _useState0[0],
    setMoveInDuration = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    comment = _useState10[0],
    setComment = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    possessionDate = _useState12[0],
    setPossessionDate = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    moveInDate = _useState14[0],
    setMoveInDate = _useState14[1];
  var prefilledUnitConfig = (_prefilledData$ = prefilledData[0]) !== null && _prefilledData$ !== void 0 && _prefilledData$.unitConfiguration ? (_prefilledData$2 = prefilledData[0]) === null || _prefilledData$2 === void 0 ? void 0 : _prefilledData$2.unitConfiguration : "";
  var prefilledUnitArea = (_prefilledData$3 = prefilledData[0]) !== null && _prefilledData$3 !== void 0 && _prefilledData$3.unitArea ? (_prefilledData$4 = prefilledData[0]) === null || _prefilledData$4 === void 0 ? void 0 : _prefilledData$4.unitArea : "";
  var _useState15 = useState(prefilledUnitArea ? prefilledUnitArea : ""),
    _useState16 = _slicedToArray(_useState15, 2),
    unitArea = _useState16[0],
    setUnitArea = _useState16[1];
  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    error = _useState18[0],
    setError = _useState18[1];
  var _usePhoneInput = usePhoneInput(),
    _usePhoneInput$state = _usePhoneInput.state,
    mobileNumberIsValid = _usePhoneInput$state.isValid,
    mobile = _usePhoneInput$state.mobile,
    country = _usePhoneInput$state.country,
    mobileHasError = _usePhoneInput$state.mobileHasError,
    isInputFocused = _usePhoneInput$state.isInputFocused,
    onChange = _usePhoneInput.onChange,
    validator = _usePhoneInput.validator,
    setMobile = _usePhoneInput.setMobile,
    setIsTouched = _usePhoneInput.setIsTouched,
    getMobileWithoutCountryCode = _usePhoneInput.getMobileWithoutCountryCode,
    setInputFocused = _usePhoneInput.setInputFocused;
  var handleChange = function handleChange(e) {
    var Value = e.target.value;
    if (!isNaN(Value)) {
      console.log("it is a number");
      setUnitArea(Value);
      setError("");
    } else {
      setError("Please enter a valid number");
    }
  };
  var calculatePlannedDate = function calculatePlannedDate(duration) {
    var currentDateObj = new Date();
    var plannedDate = new Date(currentDateObj);
    if (duration.includes("Days")) {
      var daysLimit = parseInt(duration.split("-")[1]);
      plannedDate.setDate(plannedDate.getDate() + daysLimit);
    } else if (duration.includes("Months")) {
      if (duration.includes("More than 6 Months")) {
        plannedDate.setMonth(plannedDate.getMonth() + 7);
      } else {
        var monthsLimit = parseInt(duration.split("-")[1]);
        plannedDate.setMonth(plannedDate.getMonth() + monthsLimit);
      }
    }
    return plannedDate.toISOString().slice(0, 10);
  };
  useEffect(function () {
    if (possessionDuration !== null) {
      setPossessionDate(calculatePlannedDate(possessionDuration));
    }
  }, [possessionDuration]);
  useEffect(function () {
    if (moveInDuration !== null) {
      setMoveInDate(calculatePlannedDate(moveInDuration));
    }
  }, [moveInDuration]);
  var handleunitConfigChange = function handleunitConfigChange(val) {
    setUnitConfig({
      Name: val.value,
      displayName: val.label
    });
  };
  console.log("unit Config and prefilledUnitConfig and unitArea", unitConfig.Name, prefilledUnitConfig, unitArea);
  var handleFormSubmit = function handleFormSubmit() {
    setLoading(true);
    var unitConfiguration = "";
    if (prefilledUnitConfig || prefilledData.length > 1 && !unitConfig.Name) {
      unitConfiguration = prefilledUnitConfig;
    } else if (unitConfig.Name) {
      unitConfiguration = unitConfig.Name;
    }
    var data = {
      alternatePhoneNumber: mobile,
      comments: comment,
      plannedMoveInDate: moveInDate,
      possessionDate: possessionDate,
      unitArea: unitArea,
      unitConfiguration: unitConfiguration
    };
    var url = "winnre/user/deals/consultation-deal-additional-details?dealRedemptionId=".concat(dealRedemptionId);
    winnreAuth({
      method: "POST",
      url: url,
      headers: {
        "Content-Type": "application/json;charset=utf-8"
      },
      data: JSON.stringify(data)
    }).then(function (res) {
      var _window;
      setLoading(false);
      console.log("deal enquiry", res);
      if ((res === null || res === void 0 ? void 0 : res.status) === "INVALID_TOKEN" || (res === null || res === void 0 ? void 0 : res.status) === "FAILED") {
        toast.error("Something Went Wrong");
        return;
      }
      setStep(step + 1);
      (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("OfferDetailsSubmitted", {
        alternatePhoneNumber: "".concat(mobile, " "),
        comments: "".concat(comment),
        plannedMoveInDate: "".concat(moveInDate),
        possessionDate: "".concat(possessionDate),
        unitArea: "".concat(unitArea),
        unitConfiguration: "".concat(unitConfiguration)
      });
    })["catch"](function () {
      toast.error("Something Went Wrong");
    });
  };
  var getConditionalFormSteps = function getConditionalFormSteps() {
    switch (step) {
      case 1:
        return /*#__PURE__*/_jsx(StepOne, {
          setStep: setStep,
          unitConfig: unitConfig,
          handleunitConfigChange: handleunitConfigChange,
          prefilledData: prefilledData,
          prefilledUnitConfig: prefilledUnitConfig,
          prefilledUnitArea: prefilledUnitArea,
          handleChange: handleChange,
          unitArea: unitArea,
          error: error
        });
      case 2:
        return /*#__PURE__*/_jsx(StepTwo, {
          setStep: setStep,
          possessionDuration: possessionDuration,
          setPossessionDuration: setPossessionDuration,
          moveInDuration: moveInDuration,
          setMoveInDuration: setMoveInDuration,
          mobile: mobile,
          onChange: onChange,
          validator: validator,
          setIsTouched: setIsTouched,
          setInputFocused: setInputFocused,
          mobileHasError: mobileHasError,
          comment: comment,
          setComment: setComment,
          isInputFocused: isInputFocused,
          mobileNumberIsValid: mobileNumberIsValid,
          onFormSubmit: handleFormSubmit,
          prefilledData: prefilledData
        });
      case 3:
        return /*#__PURE__*/_jsx(StepThree, {});
      default:
        /*#__PURE__*/_jsx(_Fragment, {});
    }
  };
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", {
      className: " bg-white flex items-center justify-center p-2 ",
      children: /*#__PURE__*/_jsxs("div", {
        className: "",
        children: [loading && /*#__PURE__*/_jsx(LoadingSpinner, {}), !loading && getConditionalFormSteps()]
      })
    })
  });
};
export default DealEnquiry;